import {comRequest} from "@/Fwk/Http/comRequest";
import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import type {API} from "@/app/_api/types/auth";


export async function checkPhoneRegister(params: object = {}): Promise<API.CheckPhoneRegisterResponse> {
    const config: HttpConfig = {
        url: `/hs-apis/acct/v1.0/user/check_register`,
        method: 'POST',
        body: params,
    };
    const request = await DoSendRequest<API.CheckPhoneRegisterResponse>(config);
    return request.data;
}

export async function DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
    config.isSerErrTips = true;
    const sendRequest = await comRequest<T>(config);
    return sendRequest;
}
